const WOOSMAP_PUBLIC_KEY = window._env_?.REACT_APP_WOOSMAP_PUBLIC_KEY || process.env.REACT_APP_WOOSMAP_PUBLIC_KEY || ''
const BACKEND_API_URL = window._env_?.REACT_APP_BACKEND_API_URL || process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8080'
const TENANT_ID = window._env_?.REACT_APP_TENANT_ID ||  process.env.REACT_APP_TENANT_ID || ''
const GOOGLE_PLACES_API_KEY = window._env_?.REACT_APP_GOOGLE_PLACE_API_KEY || process.env.REACT_APP_GOOGLE_PLACE_API_KEY || ''

console.log('GOOGLE_PLACES_API_KEY > ', GOOGLE_PLACES_API_KEY)

export {
  WOOSMAP_PUBLIC_KEY,
  BACKEND_API_URL,
  TENANT_ID,
  GOOGLE_PLACES_API_KEY
}
